// Module
var code = "<leaflet id=\"{{mapId}}\" layers=\"layers\" markers=\"markers\" controls=\"controls\" defaults=\"defaults\" legend=\"_mapLegend\" width=\"{{mapWidth}}\" height=\"{{mapHeight}}\"> </leaflet> ";
// Exports
export default code;